<template>
    <div class="container" v-show="isVisible()">
        <div class="card">

            <div class="card-header"><h2 class="text-center">Welcome</h2></div>
            <div class="card-body">
               <form @submit.prevent="submit">
                    <div class="form-group">       
                        <h1 v-show="!human" style="color: red">Cannot continue because you failed the human test.</h1>         
                        <ul class="list-group">
                            <li class="list-group-item active">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">You will be asked a series of questions to gather information. This information will allow us to:</h5>                                
                                </div>
                            </li>
                            <li class="list-group-item">Open a file in our secure system.</li>
                            <li class="list-group-item">Request access from VA to view and download the Veteran’s electronic VA claims file.</li>
                            <li class="list-group-item">Prepare Initial Forms*</li>
                            <li class="list-group-item">Give this firm temporary power of attorney**</li>
                            <li class="list-group-item">File notice with VA that we intend to maximize your benefits!</li>
                            <li class="list-group-item">
                                <small>
                                * Initial forms include 21-22a and 21-0966.
                                <br>
                                ** To withdraw POA, file a 21-22a with new representation.
                                </small>
                            </li>
                        </ul>
                        <br>
                        <button type="submit" class="btn btn-primary btn-block" :disabled="submitting">
                            <span v-show="submitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="false"></span>  
                            Continue
                        </button>            
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Link',
  data() {
    return {
        human: true,
        submitting: false
    }
  },  
  methods: {
    isVisible: function() {
        return this.$parent.currentQuestion === "link";
    },
    submit: function() {
        let _this = this;

        let url = new URL(window.location.href);
        let firmId = url.searchParams.get("link");

        window.grecaptcha.ready(function() {
            window.grecaptcha.execute('6Le_xI0UAAAAABEwLOM5FYHIfFGx6dA7sJfMKQo-', {action: 'login'})
            .then(function(token) {
                let url;
                if (_this.$parent.$data.dev === true) {
                    // eslint-disable-next-line
                    console.warn("Intake Form development mode is on");
                    url = "http://localhost:8080/intake";
                } else {
                    url = `../../../vch/intake`;
                }
                url+="?gRecaptchaToken="+token+"&firmId="+firmId;

                _this.$data.submitting = true;
                $.get(url, function(data){
                    _this.$data.submitting = false;
                    if (Boolean(data) === false) {
                        _this.$data.human = false;
                    } else {
                        _this.$parent.code = data;

                        /* eslint-disable */
                        console.log("firmId: " + firmId);
                        if (firmId === '0') {
                            _this.$parent.currentQuestion = "hippa"; 
                        } else {
                            _this.$parent.currentQuestion = "veteranRelationship"; 
                        }
                    }
                });
            });
        });
    }
  }
}
</script>